import {
  Condition,
  DiscountMatchType,
  DiscountOptionModel,
} from "@redotech/redo-model/return-flow/condition";
import {
  discountFromModel,
  validateDiscountCondition,
  type DiscountState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const DISCOUNT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DiscountState>>,
): ConditionType<DiscountState, Condition.Discount> => ({
  name: "Discounts",
  description(state) {
    return `Discounts: ${state.codes.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<DiscountState>) {
    return React.createElement(Details, props);
  },
  empty: {
    codes: [],
    codeOption: DiscountOptionModel.ITEM,
    matchType: DiscountMatchType.EXACT,
  },
  fromModel(model: Condition.Discount) {
    return discountFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.DISCOUNT,
      codes: state.codes,
      codeOption: state.codeOption,
      matchType: state.matchType || DiscountMatchType.EXACT,
    };
  },
  valid(state) {
    return validateDiscountCondition(state).valid;
  },
});

export { type DiscountState } from "@redotech/redo-model/return-flow/condition-validate";
